import { Authority } from 'platform/app/authority.constant';

export const USER_MANAGEMENT = {
    name: 'User management',
    icon: 'dm-users',
    path: '/user-management',
    redirectTo: '/user-management/users',
    requiresAuthority: Authority.ROLE_USERS_VIEW_EDIT,
};
